function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "icon-times"
}, "Icon Times");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.91,42.93,29,31.82a1.94,1.94,0,1,1,2.77-2.72L40,37.43l8.5-8.36a1.94,1.94,0,0,1,2.72,2.77Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.73,37.07,28.81,48.18a1.94,1.94,0,1,0,2.77,2.72l8.19-8.33,8.5,8.36A1.94,1.94,0,1,0,51,48.16Z"
});

var SvgIconTimes = function SvgIconTimes(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "aria-labelledby": "icon-times",
    id: "Layer_1",
    "data-name": "Icon Times",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "icon-times"
  }, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconTimes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-times.adad181c.svg";
export { ForwardRef as ReactComponent };